// extracted by mini-css-extract-plugin
export default {"drawer":"QS","drawerheader":"RS","retake_quiz_bottom_bar":"SS","extra_drawer":"TS","not_answered_questions":"US","question_ui":"VS","accordion_details":"WS","retake_quiz":"XS","accordions":"YS","accordion_root":"ZS","accordion_summary_text":"aT","animation":"bT","show_animation":"cT","overflow_hidden":"eT"};
    if(module.hot) {
      // 1714654895641
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  